import React from "react";
import AppetizersMenu from "./AppetizersMenu";
import PubGrubMenu from "./PubGrubMenu";
import DrinksMenu from "./DrinksMenu";
import HappyHourMenu from "./HappyHourMenu";

const MobileMenu = () => {
    return (
        <div className="mobile-menu">
            <div className="menu-tabs" id="mobile-menu">
                <AppetizersMenu />
                <PubGrubMenu />
                <DrinksMenu />
                <HappyHourMenu />
            </div>
        </div>
    );
};

export default MobileMenu;
